import { Fragment, useState, useContext, useEffect } from 'react';
import {
    InvestmentContext,
    contextActionTypes,
    PersonalInfoContext,
} from 'contexts';
import { history } from 'routes';
import { useAdditionalInfo, useStepController } from '../../../hooks';
import Switch from 'components/Switch';
import Navigation from 'components/Navigation';
import api, { endpoints } from 'api';

const {
    HAS_ADDITIONAL_PROPERTY,
    HAS_ADDITIONAL_PROPERTY_SPOUSE,
} = contextActionTypes;

function OwnedProperties({ spouse }) {
    const [choice, setChoice] = useState(null);

    const {
        investments: { properties_financed, properties_financed_spouse },
        dispatchInvestments,
    } = useContext(InvestmentContext);
    const { personalUid, spouseUid } = useContext(PersonalInfoContext);

    const { has_additional_properties, uid } = useAdditionalInfo(
        spouse ? spouseUid : personalUid
    );
    const { nextStep, previousStep } = useStepController();

    useEffect(() => {
        if (typeof has_additional_properties === 'boolean') {
            setChoice(has_additional_properties ? 0 : 1);
        }
    }, [has_additional_properties]);

    const statusChange = ({ name }) => {
        const hasProperty = name === 'yes';

        // Switch component for True, 0 and for False 1 need to provide
        setChoice(hasProperty ? 0 : 1);

        if (spouse) {
            // Update context
            dispatchInvestments({
                type: HAS_ADDITIONAL_PROPERTY_SPOUSE,
                payload: hasProperty,
            });
        } else {
            // Update context
            dispatchInvestments({
                type: HAS_ADDITIONAL_PROPERTY,
                payload: hasProperty,
            });
        }
    };

    const saveChoice = async () => {
        try {
            const req = await api({
                method: 'patch',
                url: `${endpoints.CLIENT_ADDITIONAL_INFO}${uid}/`,
                data: {
                    profile: spouse ? spouseUid : personalUid,
                    has_additional_properties: choice === 0,
                },
            });

            const res = await req.data;

            if (res) {
                history.push(nextStep.path);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const is_additional = spouse
        ? properties_financed_spouse.length
        : properties_financed.length;

    return (
        <Fragment>
            {spouse ? (
                <h1>
                    Does your <span className="color-blue">spouse</span> own any{' '}
                    <span className="color-blue">
                        {is_additional ? 'additional' : ''} properties?
                    </span>
                </h1>
            ) : (
                <h1>
                    Do you own any{' '}
                    <span className="color-blue">
                        {is_additional ? 'additional' : ''} properties?
                    </span>
                </h1>
            )}
            <p className="mb-32">This includes investment properties.</p>

            <Switch choice={choice} onChange={statusChange} />

            <Navigation
                onNext={saveChoice}
                onPrevious={() => history.push(previousStep.path)}
                disableNext={!(typeof choice === 'number')}
            />
        </Fragment>
    );
}

export default OwnedProperties;
